import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanSet } from 'src/constants/planData/canadaPlanData'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CA_LP_Corus_2025.png?w=2048&ch=width&auto=format,compress"
      title="Watch your top channels live"
      subtitle="Slice, Home Network, Flavour Network and more"
      networkSet="canada"
      planCardsConfig={{
        plans: canadaPlanSet.entertainment,
      }}
    />
  )
}
